// Game data utilities

export const loadSongs = async (collectionFilePath) => {
  try {
    const filePath = collectionFilePath || '/large_collection_with_images.json';
    const response = await fetch(filePath);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const rawSongs = await response.json();

    const songs = rawSongs.map((song) => ({
      id: song.id,
      title: song.title,
      artist: song.artist,
      album: song.album,
      release_year: song.release_year,
      spotify_track_id: extractSpotifyTrackId(song.spotify_url),
      difficulty_level: calculateDifficulty(song.popularity, song.release_year),
      album_images: song.album_images || [],
      qr_code_url: song.qr_code_url,
      popularity: song.popularity,
      duration_ms: song.duration_ms,
    }));

    console.log(`Loaded ${songs.length} songs from ${filePath}`);
    console.log('Sample songs:', songs.slice(0, 3));

    return {
      songs: songs,
      metadata: {
        total_songs: songs.length,
        source: filePath,
        loaded_at: new Date().toISOString(),
      },
    };
  } catch (error) {
    console.error(
      `Failed to load songs from ${collectionFilePath || '/large_collection_with_images.json'}:`,
      error
    );
    throw error; // Re-throw the error to be handled by the caller
  }
};

// Extract Spotify track ID from full URL
const extractSpotifyTrackId = (spotifyUrl) => {
  if (!spotifyUrl) return null;
  const match = spotifyUrl.match(/track\/([a-zA-Z0-9]+)/);
  return match ? match[1] : null;
};

// Calculate difficulty based on popularity and era
const calculateDifficulty = (popularity, releaseYear) => {
  // Higher popularity = easier (more recognizable)
  // Older songs = harder (less familiar to younger players)
  const currentYear = new Date().getFullYear();
  const ageBonus = Math.min((currentYear - releaseYear) / 20, 2); // Up to +2 for very old songs

  if (popularity >= 80) return Math.min(1 + ageBonus, 3); // Easy but gets harder with age
  if (popularity >= 60) return Math.min(2 + ageBonus, 3); // Medium
  return 3; // Hard (low popularity)
};

export const getRandomSong = (songs, usedIds = []) => {
  const availableSongs = songs.filter((song) => !usedIds.includes(song.id));

  if (availableSongs.length === 0) {
    return null;
  }

  const randomIndex = Math.floor(Math.random() * availableSongs.length);
  return { ...availableSongs[randomIndex] }; // Clone to avoid mutations
};
